/** Eixo local Y: a orientação dos aros inverte o sinal entre os lados. */
export function giroRodaPorDistancia(distancia: number, raio: number, lado: number): number {
  if (!Number.isFinite(distancia) || !Number.isFinite(raio) || raio <= 0 || !Number.isFinite(lado) || lado === 0) return 0
  return -Math.sign(lado) * distancia / raio
}
